import { render, staticRenderFns } from "./fate-core-custom.vue?vue&type=template&id=327fa4f0&scoped=true&"
import script from "./fate-core-custom.vue?vue&type=script&lang=js&"
export * from "./fate-core-custom.vue?vue&type=script&lang=js&"
import style0 from "./fate-core-custom.vue?vue&type=style&index=0&id=327fa4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327fa4f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fcs/fcs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327fa4f0')) {
      api.createRecord('327fa4f0', component.options)
    } else {
      api.reload('327fa4f0', component.options)
    }
    module.hot.accept("./fate-core-custom.vue?vue&type=template&id=327fa4f0&scoped=true&", function () {
      api.rerender('327fa4f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sheets/fate-core-custom.vue"
export default component.exports